// src/components/SavedCarsModal.jsx
import React from "react";
import { BASE_IMAGE_URL } from "../utils/api";
import useSavedCarsController from "../controllers/useSavedCarsController";
import "../styles/Modal.css";
import "../styles/SavedCars.css";
import "../styles/SavedCars.mobile.css";

export default function SavedCarsModal({ open, onClose, setCurrentView, onAddCar }) {
  if (!open) return null;

  const {
    cars,
    loading,
    error,
    deletingId,
    goAddCar,
    handleDelete,
    openInBrands,
    hintLogin,
  } = useSavedCarsController({ setCurrentView, onAddCar });

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div
        className="modal-card modal-xl"
        dir="rtl"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="modal-header">
          <h3 className="modal-title">سياراتي المحفوظة</h3>
          <button type="button" className="modal-close" onClick={onClose} aria-label="إغلاق">
            ×
          </button>
        </header>

        <div className="modal-body">
          {/* Title like the page (optional) */}
          {/* <h1 className="saved-cars__title">سياراتي المحفوظة</h1> */}

          {loading && <div className="saved-cars__state">جاري التحميل...</div>}
          {!loading && error && <div className="saved-cars__state error">{error}</div>}

          {!loading && cars.length === 0 && (
            <div className="saved-cars__empty" style={{ paddingBottom: 8 }}>
              {hintLogin ? (
                <span style={{ opacity: 0.9 }}>يرجى تسجيل الدخول</span>
              ) : (
                <div className="saved-cars__hint">لا توجد سيارات محفوظة حالياً.</div>
              )}
              <button
                type="button"
                className={`saved-cars__add ${hintLogin ? "is-disabled" : ""}`}
                onClick={() => {
                  if (!hintLogin) {
                    goAddCar();
                    onClose?.();
                  }
                }}
                disabled={hintLogin}
                aria-label="إضافة سيارة"
                title={hintLogin ? "سجّل الدخول لإضافة سياراتك" : "إضافة سيارة"}
              >
                +
              </button>
            </div>
          )}

          {!loading && cars.length > 0 && (
            <div className="saved-cars__list">
              {cars.map((car) => {
                const id = car.id;
                const name = car.name || "—";
                const year = car.year_id ? String(car.year.year) : "—";
                const model = car.year_id ? String(car.year.model.name) : "—";
                const brand = car.year_id ? String(car.year.model.brand.name) : "—";
                const img =
                  typeof car.year?.model?.brand?.image === "string"
                    ? (car.year.model.brand.image.startsWith("http")
                        ? car.year.model.brand.image
                        : `${BASE_IMAGE_URL}${car.year.model.brand.image}`)
                    : "/src/assets/images/default.jpg";

                return (
                  <article
                    key={id}
                    className="saved-cars__card"
                    onClick={() => {
                      openInBrands(car); // navigate with prefill
                      onClose?.();
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        openInBrands(car);
                        onClose?.();
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {/* delete button on the LEFT of the card */}
                    <button
                      className="saved-cars__delete"
                      onClick={(e) => {
                        e.stopPropagation(); // don’t trigger openInBrands
                        handleDelete(id);
                      }}
                      disabled={deletingId === id}
                      aria-label="حذف السيارة من المحفوظة"
                      title="حذف"
                    >
                      <svg width="58" height="48" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m2 0-1.2 14.4A2 2 0 0 1 15.8 22H8.2a 2 2 0 0 1-1.99-1.6L5 6"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>

                    <div className="saved-cars__card-inner">
                      <div className="saved-cars__specs">
                        <div className="saved-cars__thumb">
                          {img ? <img src={img} alt={name} /> : <div className="saved-cars__noimg">لا توجد صورة</div>}
                        </div>

                        <div className="spec-col">
                          <div className="spec-row">
                            <span className="spec-k">نوع السيارة:</span>
                            <span className="spec-v">{brand}</span>
                          </div>
                          <div className="spec-row">
                            <span className="spec-k">الموديل:</span>
                            <span className="spec-v">{model}</span>
                          </div>
                        </div>

                        <div className="spec-col">
                          <div className="spec-row">
                            <span className="spec-k">سنة الصنع:</span>
                            <span className="spec-v">{year}</span>
                          </div>
                          <div className="spec-row">
                            <span className="spec-k">فئة السيارة:</span>
                            <span className="spec-v">{name}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
